/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegacyTournamentStageCreateRequest
 */
export interface LegacyTournamentStageCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentStageCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentStageCreateRequest
     */
    stageType: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyTournamentStageCreateRequest
     */
    orderIndex: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentStageCreateRequest
     */
    bracket?: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyTournamentStageCreateRequest
     */
    defaultBlockDurationMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof LegacyTournamentStageCreateRequest
     */
    interMatchBreakMinutes?: number;
}

/**
 * Check if a given object implements the LegacyTournamentStageCreateRequest interface.
 */
export function instanceOfLegacyTournamentStageCreateRequest(value: object): value is LegacyTournamentStageCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('stageType' in value) || value['stageType'] === undefined) return false;
    if (!('orderIndex' in value) || value['orderIndex'] === undefined) return false;
    return true;
}

export function LegacyTournamentStageCreateRequestFromJSON(json: any): LegacyTournamentStageCreateRequest {
    return LegacyTournamentStageCreateRequestFromJSONTyped(json, false);
}

export function LegacyTournamentStageCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegacyTournamentStageCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'stageType': json['stageType'],
        'orderIndex': json['orderIndex'],
        'bracket': json['bracket'] == null ? undefined : json['bracket'],
        'defaultBlockDurationMinutes': json['defaultBlockDurationMinutes'] == null ? undefined : json['defaultBlockDurationMinutes'],
        'interMatchBreakMinutes': json['interMatchBreakMinutes'] == null ? undefined : json['interMatchBreakMinutes'],
    };
}

export function LegacyTournamentStageCreateRequestToJSON(json: any): LegacyTournamentStageCreateRequest {
    return LegacyTournamentStageCreateRequestToJSONTyped(json, false);
}

export function LegacyTournamentStageCreateRequestToJSONTyped(value?: LegacyTournamentStageCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'stageType': value['stageType'],
        'orderIndex': value['orderIndex'],
        'bracket': value['bracket'],
        'defaultBlockDurationMinutes': value['defaultBlockDurationMinutes'],
        'interMatchBreakMinutes': value['interMatchBreakMinutes'],
    };
}

